
export const environment = {
  production: false,
  U_EXPO_ROOT_URL: 'https://u.expo.shnu.edu.cn',
  U_ROOT_URL: 'https://expo-u.oss-cn-shanghai.aliyuncs.com/miniprogram/u.linktour.com',
  S_ROOT_URL: 'https://expo-u.oss-cn-shanghai.aliyuncs.com/miniprogram/s.linktour.com',
  MAP_URL: 'https://edumap.shnu.edu.cn/start',
  VR_720_URL: 'https://expo.shnu.edu.cn/2022-720/',
  EDU_SCENE_URL: 'https://expo.shnu.edu.cn/case/', // 先用PRO 代替
   //EDU_SCENE_URL: 'https://eduscene.linktour.vip/', // TODO FAT 云体验webview地址, 需要替换成自己的
  QR_HOST: 'https://api.expo.shnu.edu.cn/miniprogram-eduexpo/v1/qrcode?size=200&url=',


   API_HOST: 'https://expo-api.ghz-tech.com:8185/frontend', // fat
  //API_HOST: 'https://api.expo.shnu.edu.cn/frontend', // pro
};

